/**
 * @desc 查询中台是否已创建退货单
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(
  params: API.omsFlow.asMaterialRejectBillFacadeImpl.checkCreatedReturn.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/rpc/asMasterialReject/checkCreatedReturn`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
